import { parse, stringify } from 'query-string';
import { useCallback } from 'react';
// import { useQueryClient } from 'react-query';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { TaskId } from 'api/models';
// import { TaskAPI } from 'api/tasks';
import { useTaskDrawerContext } from 'contexts/providers/task-pane';
// import { getTaskDetailQueryKey } from 'queries/task';

export enum TaskDrawerTab {
  Conversations = 'conversations',
  Approvals = 'approvals',
}

export const stringifyTaskDrawerParam = ([
  ,
  projectId,
  taskId,
]: TaskId): string => {
  return [projectId, taskId].join('.');
};

type ParseTaskDrawerFunc = (str: string) =>
  | {
      project_id: number;
      task_id: number;
    }
  | undefined;

type Groups = {
  project_id: string;
  task_id: string;
};

const getGroupsFromString = (str: string): Groups | undefined => {
  return str.match(/^(?<project_id>\d+)\.(?<task_id>\d+)$/)?.groups as
    | Groups
    | undefined;
};

export const parseTaskDrawerParam: ParseTaskDrawerFunc = (str) => {
  const groups = getGroupsFromString(str);

  if (!groups) {
    return groups;
  }

  const project_id = parseInt(groups.project_id ?? '', 10);
  const task_id = parseInt(groups.task_id ?? '', 10);

  return { project_id, task_id };
};

type ConversationTab = {
  tab: TaskDrawerTab.Conversations;
};

type ApprovalsTab = {
  tab: TaskDrawerTab.Approvals;
  showNewApproval?: 'true';
};

type TaskDetailTab = ConversationTab | ApprovalsTab;

export type TaskDrawerHashParams = Partial<TaskDetailTab>;

type NavigateToTaskReturnProps = {
  (taskId: TaskId, params?: TaskDrawerHashParams, path?: string): void;
};

type TaskDrawerHash = {
  task_drawer: string;
};

type TaskDrawerParams = {
  task_drawer_tab: TaskDrawerTab;
  show_new_approval?: 'true';
};

const getDrawerTab = (params: Partial<TaskDetailTab>): TaskDrawerParams => {
  switch (params.tab) {
    case TaskDrawerTab.Approvals:
      return {
        task_drawer_tab: TaskDrawerTab.Approvals,
        show_new_approval: params.showNewApproval,
      };
    case TaskDrawerTab.Conversations:
    default:
      return { task_drawer_tab: TaskDrawerTab.Conversations };
  }
};

type GetTaskDetailUrlFunc = (
  taskId: TaskId,
  params: TaskDrawerHashParams,
  currentUrlHash?: string,
) => string;

export const getTaskDetailUrl: GetTaskDetailUrlFunc = (
  taskId,
  params,
  currentUrlHash,
): string => {
  const baseHash: TaskDrawerHash = {
    task_drawer: stringifyTaskDrawerParam(taskId),
  };
  const parsedCurrentUrlHash = currentUrlHash ? parse(currentUrlHash) : {};

  delete parsedCurrentUrlHash.notifications;

  const hash = {
    ...parsedCurrentUrlHash,
    ...baseHash,
    ...getDrawerTab(params),
  };

  return `#${stringify(hash, { sort: false })}`;
};

const defaultParams: TaskDrawerHashParams = {
  tab: TaskDrawerTab.Conversations,
};

export const useNavigateToTask = (): NavigateToTaskReturnProps => {
  const { push } = useHistory();
  const { search, hash, pathname } = useLocation();
  // const queryClient = useQueryClient();
  const { setVisibility } = useTaskDrawerContext();

  return useCallback(
    (taskId, params = defaultParams, path = pathname) => {
      setVisibility(true);

      push({
        pathname: path,
        search,
        hash: getTaskDetailUrl(taskId, params, hash),
      });

      // queryClient.prefetchQuery({
      //   queryKey: getTaskDetailQueryKey(taskId),
      //   queryFn: () => TaskAPI.getTask(taskId[1], taskId[2]),
      // });
    },
    [pathname, setVisibility, push, search, hash],
  );
};
